'use client';

import {NavigationMenu} from '@/components/ui/navigation-menu';
import {useNavigationStateContext} from '@/context/NavigationProvider';
import {cn} from '@/lib/utils';
import type CustomerDetails from '@/types/CustomerDetails';
import type Navigation from '@/types/Navigation';
import type {NavigationGroup} from '@/types/Navigation';
import type OnboardingStep from '@/types/OnboardingStep';
import NavigationContent from './NavigationContent';

type NavigationProps = {
  customerDetails: CustomerDetails;
  navigationGroups?: NavigationGroup[];
  profileProgress?: {label: string; completed: boolean}[];
  serviceModule?: Navigation['serviceModule'];
  step?: OnboardingStep;
};

export default function Navigation({
  customerDetails,
  navigationGroups,
  profileProgress,
  serviceModule,
  step,
}: NavigationProps) {
  const {isNavOpen} = useNavigationStateContext();
  const navigationMenuClasses = cn('navigation', {
    navigation_open: isNavOpen,
  });

  return (
    <NavigationMenu className={navigationMenuClasses}>
      <NavigationContent
        customerDetails={customerDetails}
        navigationGroups={navigationGroups}
        profileProgress={profileProgress}
        serviceModule={serviceModule}
        step={step}
      />
    </NavigationMenu>
  );
}
